import React from 'react';
import ScheduledMessageShowPage from './components/ScheduledMessageShowPage';

function ScheduledMessageShow() {
  return <ScheduledMessageShowPage mode="user" />;
}

export default ScheduledMessageShow;
